// @flow
import { ofType } from 'redux-observable';
import { catchError, map, mergeMap } from 'rxjs/operators';
import { of } from 'rxjs';
import { registerStoreApi } from './api';
import update from 'immutability-helper';

import type { HTTPError } from '../../error';
import type { Observable } from 'rxjs';
import type { TiendaRequest } from './api';

export type TiendasAction = {
  +type: string;
  +tiendaRequest?: TiendaRequest;
  +error?: HTTPError;
};

export type TiendasState = {
  +isRegistering?: boolean;
  +registrationSuccess?: boolean;
  +registrationError?: HTTPError;
};

// Actions
const TIENDAS_REGISTER_REQUEST = 'TIENDAS_REGISTER_REQUEST';
const TIENDAS_REGISTER_SUCCESS = 'TIENDAS_REGISTER_SUCCESS';
const TIENDAS_REGISTER_ERROR = 'TIENDAS_REGISTER_ERROR';

const TIENDAS_RESET_STATE = 'TIENDAS_RESET_STATE';

export function registerStore(tiendaRequest: TiendaRequest): TiendasAction {
  return {
    type: TIENDAS_REGISTER_REQUEST,
    tiendaRequest,
  };
}

export function registerStoreSuccess(): TiendasAction {
  return {
    type: TIENDAS_REGISTER_SUCCESS,
  };
}

export function registerStoreErrorFn(error: HTTPError): TiendasAction {
  return {
    type: TIENDAS_REGISTER_ERROR,
    error,
  };
}

export function resetState() {
  return {
    type: TIENDAS_RESET_STATE,
  };
}

export const actions = {
  TIENDAS_REGISTER_REQUEST,
  TIENDAS_REGISTER_SUCCESS,
  TIENDAS_REGISTER_ERROR,
  TIENDAS_RESET_STATE,
  registerStore,
  registerStoreSuccess,
  registerStoreErrorFn,
  resetState,
};

export const initialState: TiendasState = {};

export default function reducer(state: TiendasState = initialState,
                                action: TiendasAction): TiendasState {
  switch (action.type) {
    case TIENDAS_REGISTER_REQUEST:
      return update(state, {
        isRegistering: { $set: true },
        $unset: ['registrationError'],
      });
    case TIENDAS_REGISTER_SUCCESS:
      return update(state, {
        registrationSuccess: { $set: true },
        $unset: ['isRegistering'],
      });
    case TIENDAS_REGISTER_ERROR:
      return update(state, {
        registrationError: { $set: action.error },
        $unset: ['isRegistering'],
      })
    case TIENDAS_RESET_STATE:
      return initialState;
    default:
      return state;
  }
}

// Epics
export function registerStoreEpic(action$: Observable<TiendasAction>): Observable<TiendasAction> {
  return action$.pipe(
    ofType(TIENDAS_REGISTER_REQUEST),
    mergeMap(({ tiendaRequest }) =>
      registerStoreApi(tiendaRequest).pipe(
        map(registerStoreSuccess),
        catchError((e: HTTPError) => of(registerStoreErrorFn(e))),
      )),
  );
}



// WEBPACK FOOTER //
// ./src/modules/tiendas/duck.js